import { render, staticRenderFns } from "./InfraSummary.vue?vue&type=template&id=1be0c853&scoped=true&"
import script from "./InfraSummary.vue?vue&type=script&lang=js&"
export * from "./InfraSummary.vue?vue&type=script&lang=js&"
import style0 from "./InfraSummary.vue?vue&type=style&index=0&id=1be0c853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0c853",
  null
  
)

export default component.exports